import React, { useEffect } from 'react';

const AccountCreate: React.FC = () => {
  useEffect(() => {
    const closeTimer = window.setTimeout(() => {
      try {
        window.close();
      } catch {
      }

      window.location.replace('/settings?tab=linkAccount');
    }, 1500);

    return () => window.clearTimeout(closeTimer);
  }, []);

  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-blue-50 via-white to-blue-100">
      <div className="text-center px-6 py-12 animate-fade-in">

        <div className="relative inline-flex items-center justify-center mb-8">
          <div className="absolute w-32 h-32 bg-blue-200 rounded-full animate-ping opacity-60"></div>
          <svg
            className="relative w-32 h-32 text-blue-600 animate-bounce-in"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </div>

        <h1 className="text-4xl font-bold text-blue-600 mb-4 animate-slide-up">
          Account Created Successfully!
        </h1>

        <div className="max-w-md mx-auto bg-white rounded-2xl shadow-lg p-8 animate-slide-up-delay">
          <p className="text-lg text-gray-700 mb-6">
            Your account has been successfully created.
          </p>

          <p className="text-gray-600">
            You may now close this window or return to the app.
          </p>
        </div>
      </div>

      <style>{`
        @keyframes fade-in {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes slide-up {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes bounce-in {
          0% { transform: scale(0); opacity: 0; }
          50% { transform: scale(1.1); }
          100% { transform: scale(1); opacity: 1; }
        }
        .animate-fade-in { animation: fade-in 0.5s ease-out; }
        .animate-slide-up { animation: slide-up 0.6s ease-out; }
        .animate-slide-up-delay { animation: slide-up 0.6s ease-out 0.2s both; }
        .animate-bounce-in { animation: bounce-in 0.6s cubic-bezier(0.68,-0.55,0.265,1.55); }
      `}</style>
    </div>
  );
};

export default AccountCreate;